import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Serializing from "./components/Serializing";
import Updates from "./components/Updates";
import Completed from "./components/Completed";
import HowItWorks from "./components/HowItWorks";
import FAQ from "./components/FAQ";
import About from "./components/About";
import Footer from "./components/Footer";

export default function Home() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <Hero />
      <Serializing />
      <Updates />
      <Completed />
      <HowItWorks />
      <FAQ />
      <About />
      <Footer />

      {showTop && (
        <a
          href="#top"
          aria-label="返回顶部"
          className="fixed bottom-6 right-6 z-50 flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 text-background-50 shadow-none transition hover:bg-primary-600"
        >
          <i className="ri-arrow-up-line text-lg"></i>
        </a>
      )}
    </main>
  );
}